import React from 'react';
const Button = ({children}) => {
    return (
        <a href='https://discord.com/oauth2/authorize?client_id=1050164784609366057&scope=bot&permissions=284355702' className=' uppercase text-3xl border-gray-600 border bg-card text-white p-6 hover:bg-slate-600 transition-all rounded-xl m-auto'>
            {children}
        </a>
    );
};

export default Button;